import { toast } from "react-toastify";

export function showApiErrors(error) {
  if (error.response && error.response.data) {
    const errData = error.response.data;
    
    // Case 1: Errors are in { data: { field: [messages] } } format
    if (errData.data && typeof errData.data === "object") {
      Object.entries(errData.data).forEach(([field, messages]) => {
        if (Array.isArray(messages)) {
          messages.forEach((msg) => {
            toast.error(`${formatFieldName(field)} field error: ${msg}`);
          });
        } else if (typeof messages === "string") {
          toast.error(`${formatFieldName(field)} field error: ${messages}`);
        }
      });
    } 
    
    else if (typeof errData.data === "string") {
      toast.error(errData.message);
    }
    else if (errData.data == null && errData.message) {
      toast.error(errData.message);
    }
    
    else {
      toast.error("Something went wrong. Please try again.");
    }
  } else {
    toast.error("Something went wrong. Please try again.");
  }
}

function formatFieldName(field) {
  return field
    .replace(/_/g, " ") 
    .replace(/([a-z])([A-Z])/g, "$1 $2") 
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

